import gql from 'graphql-tag'

export const GET_LOG_NOTIFICATIONS = gql`
  query AlertRuleAuditLogs($filter: GetAlertRuleAuditLogsFilter) {
  alertRuleAuditLogs(filter: $filter) {
    isSuccessful
    errorCode
    errorName
    message
    status
    alertRuleAuditLogs {
      data {
        time
        user
        actionType
        object
        alertRuleId
        label
      }
      pagination {
        total
        page
        show
      }
    }
  }
}
`

export const GET_DETAIL_LOG_NOTIFICATION = gql`
  query AlertRuleAuditLogs($filter: GetAlertRuleAuditLogsFilter) {
  alertRuleAuditLogs(filter: $filter) {
    isSuccessful
    errorCode
    errorName
    message
    status
    alertRuleAuditLogs {
      data {
        time
        actionType
        user
        changes {
          detail
          object
        }
      }
      pagination {
        total
        page
        show
      }
    }
  }
}
`